import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Organization } from 'src/app/domain/organization/dto/Organization';
import { ERROR_IMAGE_LINK } from 'src/app/domain/cabinet/component/cabinet/cabinet.component';
import { OrganizationAccesses } from '../../service/organizations.service';

@Component({
  selector: 'app-organization-info-card',
  templateUrl: './organization-info-card.component.html',
  styleUrls: ['./organization-info-card.component.scss'],
})
export class OrganizationInfoCardComponent {

  @Input() organization: Organization;
  @Input() isAdmin = false;
  @Input() orgAccess: OrganizationAccesses;
  @Output() editOrg = new EventEmitter<Organization>();

  errorImageLink = ERROR_IMAGE_LINK;

  goToOrgWebSite(): void {
    if (!this.organization.webSiteLink.includes('http')) {
      this.organization.webSiteLink = 'https://' + this.organization.webSiteLink;
    }
    window.open(this.organization.webSiteLink);
  }

  openAddressInGoogleMaps(): void {
    window.open('https://www.google.com/maps/place/' + this.organization.address);
  }

}
